/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-14 11:57:45
 * @LastEditors: limin
 * @LastEditTime: 2021-04-14 15:06:14
 */
 //系统错误捕获
const errorHandler = (error)=>{
  console.log(error);
  console.error('捕获全局异常,后退一页');
  // window.onClickLeft()
}
export default errorHandler
